import { storeService } from '@/services/store.service';

const initialState = {
  data: {},
  isLoading: false,
  error: {},
};

export const storeX = {
  namespaced: true,
  state: initialState,
  getters: {
    store: (state) => state.data,
    isLoadingStore: (state) => state.isLoading,
    error: (state) => state.error,
  },
  mutations: {
    loading(state) {
      state.isLoading = true;
    },
    loadingSuccess(state) {
      state.isLoading = false;
    },
    setData(state, data) {
      state.data = data;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async getStoreList({ commit }, params) {
      commit('loading');
      try {
        const response = await storeService.getStoreList(params);
        commit('setData', response);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('loadingSuccess');
      }
    },

    async getDetail({ commit }, { id }) {
      commit('loading');
      try {
        const response = await storeService.getDetail(id);
        commit('setData', response);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('loadingSuccess');
      }
    },
  },
};
